import React, { Fragment } from "react";
import { Col } from "reactstrap";

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  const handlePageClick = (page, event) => {
    event.preventDefault(); // Prevent default anchor tag behavior
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 10; // Maximum number of pages to display
    const halfVisible = Math.floor(maxVisiblePages / 2);
    
    let startPage = Math.max(1, currentPage - halfVisible);
    let endPage = Math.min(totalPages, currentPage + halfVisible);

    // Adjust the start and end if there are not enough pages
    if (endPage - startPage < maxVisiblePages - 1) {
      if (startPage === 1) {
        endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
      } else if (endPage === totalPages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""} border-0`}
        >
          <a
            href="#"
            className="page-link"
            onClick={(e) => handlePageClick(i, e)} // Pass event to the handler
          >
            {i}
          </a>
        </li>
      );
    }
    return pageNumbers;
  };

  return (
    <Fragment>
      <Col xs="12" className="mb-2">
        <nav aria-label="...">
          <ul className="pagination pagination-primary justify-content-end simple-list d-flex flex-row">
            {/* Previous button */}
            <li
              className={`page-item ${currentPage === 1 ? "disabled" : ""} border-0`}
            >
              <a
                className="page-link"
                href="#"
                tabIndex="-1"
                onClick={(e) => handlePageClick(currentPage - 1, e)} // Pass event to the handler
              >
                Previous
              </a>
            </li>
            {/* Page numbers */}
            {renderPageNumbers()}
            {/* Next button */}
            <li
              className={`page-item ${currentPage === totalPages ? "disabled" : ""} border-0`}
            >
              <a
                className="page-link"
                href="#"
                onClick={(e) => handlePageClick(currentPage + 1, e)} // Pass event to the handler
              >
                Next
              </a>
            </li>
          </ul>
        </nav>
      </Col>
    </Fragment>
  );
};

export default Pagination;